import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey as BaseQuickKey, QuickKeyProps } from "../../../QuickKey";

export type CancelSaleQuickKeyProps = QuickKeyProps & {};

export const CancelSaleQuickKey = React.forwardRef<
  any,
  CancelSaleQuickKeyProps
>(({ disabled: _disabled, ..._props }, ref) => {
  const [disabled, setDisabled] = React.useState(true);

  const { sale } = useSaleControllerProvider();
  const { colors: Colors } = useTheme();
  const navigation = useNavigation<SellScreenProps["navigation"]>();
  const backgroundColor = Colors.destructive;

  React.useEffect(() => {
    (async () => {
      if (sale) {
        const canTransition = await sale.canTransitionCancel;

        setDisabled(canTransition == false);
      }
    })();
  }, [sale]);

  const onPress = useCallback(() => {
    if (!sale) return;
    navigation.navigate("ActionsRootScreen", {
      screen: "CancelSaleScreen",
    });
  }, [sale]);

  const label = sale ? `Cancel ${sale.saleType}` : "Cancel Sale";

  return (
    <BaseQuickKey
      {...{ backgroundColor, disabled: _disabled ?? disabled }}
      ref={ref}
      onPress={onPress}
      label={label}
      iconPrimary={
        <AntDesign name="closecircle" size={24} color={Colors.white} />
      }
      isDestructive={true}
      isAction={false}
      {..._props}
    />
  );
});
